import { useMainStore } from '@/store'
import { computed } from 'vue'

const MIN_INTERVAL = 0.5
const MAX_INTERVAL = 60

export const useInterval = () => {
  const store = useMainStore()
  const interval = computed(() => store.interval)

  const minus = () => {
    if (interval.value > MIN_INTERVAL) {
      store.setInterval(Math.max(interval.value - 1, MIN_INTERVAL))
    }
  }

  const plus = () => {
    store.setInterval(Math.min(Math.floor(interval.value + 1), MAX_INTERVAL))
  }

  const isMinuteSession = computed(() => interval.value >= 1)

  return {
    interval,
    isMinuteSession,
    minInterval: MIN_INTERVAL,
    minus,
    plus
  }
}
